import { memo } from 'react'

import { AudioCirclePlayer } from '../../../../audio-circle-player'

import { Text } from 'common-components'

import * as Styled from './styled'
import { getMusicVersionLabel } from '../helpers'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import { IUserAudio } from 'store/types/audio'

interface IProps {
  isSelected: boolean
  version: IUserAudio
  onClick: (version: IUserAudio) => void
  currentPlayingAudioRef: React.MutableRefObject<null>
}
const Version: React.FC<IProps> = ({
  version,
  isSelected,
  currentPlayingAudioRef,
  onClick
}) => {
  const { duration, path } = version

  return (
    <Styled.MusicVersionWrapper
      $isSelected={isSelected}
      onClick={() => {
        if (!isSelected) {
          onClick(version)
        }
      }}
      className="vm-music-versions"
    >
      <Styled.MusicVersionLeftBox>
        <AudioCirclePlayer
          src={path}
          currentPlayingAudioRef={currentPlayingAudioRef}
        />
        <Text type="h4">{getMusicVersionLabel(duration)}</Text>
      </Styled.MusicVersionLeftBox>

      {isSelected && <CheckIcon />}
    </Styled.MusicVersionWrapper>
  )
}

export default memo(Version)
